<template>
  <div class="payment-detail">
    <div class="payment-detail-top">
      <div class="top-title">
        <span>订单详情</span>
        <div class="refund" @click="handleRefund()">退款</div>
      </div>
      <div class="order-desc">
        <div class="top-title order-title">
          订单编号：{{ orderInfo.orderCode || "-" }}
        </div>
        <el-descriptions
          :column="4"
          :colon="false"
          :labelStyle="{
            fontSize: '14px',
            fontWeight: '500',
            color: '#86909C',
            width: '70px',
          }"
          :contentStyle="{
            fontSize: '14px',
            fontWeight: '400',
            color: '#1D2129',
          }"
        >
          <el-descriptions-item label="订单类型">
            支付订单
          </el-descriptions-item>
          <el-descriptions-item label="平台订单ID">
            {{ orderInfo.transactionId }}
          </el-descriptions-item>
          <el-descriptions-item label="用户">
            <span
              style="cursor: pointer; color: #165dff"
              @click="toUserDetail(orderInfo.userId)"
            >
              {{ orderInfo.un || "-" }}
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="状态">
            {{ payStatus[orderInfo.status] || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="支付通道">{{
            paymentChannelMap[orderInfo.paymentChannel] || "-"
          }}</el-descriptions-item>
          <el-descriptions-item label="会员内容">{{
            orderInfo.content || "-"
          }}</el-descriptions-item>
          <el-descriptions-item label="提交时间">
            {{ orderInfo.createdAt || "-" }}
          </el-descriptions-item>
          <el-descriptions-item label="订单金额"
            >{{ orderInfo.amount || "-" }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <div class="payment-detail-top payment-detail-info">
      <div class="">
        <span class="top-title">支付信息</span>
        <div class="table-space">
          <div class="table-title">
            <div class="table-title-item">结算订单号</div>
            <div class="table-title-item">支付金额</div>
            <div class="table-title-item">币种</div>
            <div class="table-title-item">支付方式</div>
          </div>
          <div class="table-content">
            <div class="table-content-item">{{ orderInfo.code || "-" }}</div>
            <div class="table-content-item">
              {{ orderInfo.paymentAmount || "-" }}
            </div>
            <div class="table-content-item">
              {{ orderInfo.currency || "-" }}
            </div>
            <div class="table-content-item">
              {{ orderInfo.paymentMethod || "-" }}
            </div>
          </div>
        </div>
        <span class="top-title" style="margin-top: 20px">退款信息</span>
        <div class="table-space">
          <div class="table-title">
            <div class="table-title-item">退款金额</div>
            <div class="table-title-item">币种</div>
            <div class="table-title-item">退款时间</div>
            <div class="table-title-item">退款操作人</div>
          </div>
          <div class="table-content">
            <div class="table-content-item">
              {{ orderInfo.paymentAmount || "-" }}
            </div>
            <div class="table-content-item">
              {{ orderInfo.currency || "-" }}
            </div>
            <div class="table-content-item">
              {{ orderInfo.refundTime || "-" }}
            </div>
            <div class="table-content-item">
              {{ orderInfo.operator || "-" }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <refundDialog
      :showRefund="showRefund"
      :orderId="orderId"
      @closefn="showRefund = false"
      @editsubfn="editsubfn"
    ></refundDialog>
  </div>
</template>

<script>
import refundDialog from "./components/refundDialog.vue";
export default {
  components: {
    refundDialog,
  },
  data() {
    return {
      showRefund: false,
      orderId: "",
      orderInfo: {},
      payStatus: { 1: "支付成功", 2: "退款" },
      paymentChannelMap: {
        1: "IOS",
        2: "android",
        3: "微信",
      },
      vipAll: {},
      vipSelectList: [],
    };
  },
  created() {
    const vipAll = localStorage.getItem("VIP_ALL");
    if (vipAll) {
      this.vipAll = JSON.parse(vipAll);

      for (const key in this.vipAll) {
        if (this.vipAll.hasOwnProperty(key)) {
          this.vipSelectList.push({
            key: key,
            value: this.vipAll[key],
          });
        }
      }
    }
  },
  mounted() {
    this.orderId = this.$route.query.id;
    if (this.orderId) {
      this.getOrderDetail();
    }
  },
  methods: {
    editsubfn() {
      this.getOrderDetail();
    },
    handleRefund(id) {
      this.showRefund = true;
      this.curId = id;
    },
    toUserDetail(uid) {
      if (this.$jumpPerm("user_detail")) {
        this.$router.push({
          path: "/userDetail",
          query: {
            id: uid,
            tabs: "first",
          },
        });
      } else {
        this.$message({
          type: "error",
          message: "没有权限",
        });
      }
    },
    getOrderDetail() {
      this.$get("/vip/order/details", { id: this.orderId }).then((res) => {
        if (res.data.code === 1000) {
          this.orderInfo = res.data?.data || {};
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.payment-detail {
  display: flex;
  height: 100%;
  flex-direction: column;
}
.payment-detail-top {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  border-radius: 4px;
}
.top-title {
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  font-size: 16px;
  color: #1d2129;
}
.refund {
  width: 60px;
  height: 32px;
  background: #f2f3f5;
  border-radius: 2px 2px;
  font-weight: 400;
  font-size: 14px;
  color: #4e5969;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.order-desc {
  margin-top: 20px;
}
.order-title {
  margin-bottom: 16px;
}
.payment-detail-info {
  margin-top: 20px;
  // height: 100%;
}
.table-space {
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  border: 1px solid #e5e6eb;
}
.table-title {
  display: flex;
  width: 100%;
  background-color: #f2f3f5;
  padding: 7px 16px;
  box-sizing: border-box;
  font-weight: 600;
  font-size: 14px;
  color: #1d2129;
  border-bottom: 1px solid #e5e6eb;
}
.table-title-item {
  display: flex;
  width: 25%;
}
.table-content {
  display: flex;
  width: 100%;
  padding: 14px 16px;
  box-sizing: border-box;
}
.table-content-item {
  display: flex;
  width: 25%;
  font-weight: 400;
  font-size: 14px;
  color: #1d2129;
}
</style>
